import { ReactElement } from 'react';
import { usePrevious, useUpdateEffect } from 'react-use';

import { TimeOfDay } from '@dreryk/egabinet-waitlist-frontend-api';

import { FormController } from '@dreryk/react-components';
import { BindingCreator, ValidationRules } from '@dreryk/react-common';

import { WaitlistFormBean, WaitlistFormController } from '../../WaitlistForm.types';
import { translationKeys } from '../../../translations';
import { DAYS_OF_WEEK } from '../AllDaysPreferencesField/AllDaysPreferencesField.constants';

import { StyledDayTimePreferencesField } from './DayTimePreferencesField.styled';

type DayTimePreferencesFormBeanPart = Pick<WaitlistFormBean, 'dayTimePreferencesValidation'>;

const validationRules: ValidationRules<DayTimePreferencesFormBeanPart> = {
   validate: (data, getValue) => {
      const dayTimePreferences = DAYS_OF_WEEK.map((dayOfWeek) =>
         getValue(`dayTimePreferences.${dayOfWeek}`)
      ).flat() as TimeOfDay[];
      if (data === true || dayTimePreferences.length === 0) {
         return translationKeys.chooseAtLeastOneDayWeekAndTimePreference;
      }
      return undefined;
   },
};

type DayTimePreferencesFieldProps = Pick<WaitlistFormController, 'watch' | 'trigger'> & {
   register: BindingCreator<DayTimePreferencesFormBeanPart, 'dayTimePreferencesValidation'>;
};

export const DayTimePreferencesField = (props: DayTimePreferencesFieldProps): ReactElement => {
   const currentValue = props.watch('dayTimePreferencesValidation');
   const previousValue = usePrevious(currentValue);

   useUpdateEffect(() => {
      if (currentValue !== previousValue) {
         props.trigger('dayTimePreferencesValidation');
      }
   }, [currentValue]);

   return (
      <StyledDayTimePreferencesField>
         <FormController controller={props.register('dayTimePreferencesValidation', validationRules)} />
      </StyledDayTimePreferencesField>
   );
};
